import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

export const MultibetIframeWrapper = withConfig(theme => styled('div', { label: 'MultibetIframeWrapper' })`
    position: relative;
    width: 100%;
    min-height: 600px;
    background-color: ${theme.star.eventRow.bgColor};
    overflow: hidden;
    transition: all 0.3s ease;

    @media ${theme.star.mediaQuery.mobile} {
        min-height: 500px;
    }

    @media ${theme.star.mediaQuery.tablet} {
        min-height: 550px;
    }

    @media ${theme.star.mediaQuery.desktop} {
        min-height: 600px;
    }
`);

export const MultibetIframe = withConfig(theme => styled('iframe', { label: 'MultibetIframe' })`
    width: 100%;
    height: 600px;
    border: none;
    display: block;
    background-color: white;

    @media ${theme.star.mediaQuery.mobile} {
        height: 500px;
    }

    @media ${theme.star.mediaQuery.tablet} {
        height: 550px;
    }

    @media ${theme.star.mediaQuery.desktop} {
        height: 600px;
    }
`);

export const MultibetLoader = styled(Loader, { label: 'MultibetLoader' })`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
`;

export const MultibetLoginRequiredWrapper = withConfig(theme => styled('div', { label: 'MultibetLoginRequiredWrapper' })<{variant: DefaultComponentVariantType | null}>`
    position: relative;
    width: 100%;
    min-height: 600px;
    background-color: ${({variant}) => variant === DefaultComponentVariantType.TERTIARY ? theme.star.unified.eventsTableInfo.bgColor : theme.star.eventRow.bgColor};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    text-align: center;

    @media ${theme.star.mediaQuery.mobile} {
        min-height: 500px;
    }

    @media ${theme.star.mediaQuery.tablet} {
        min-height: 550px;
    }
`);

export const MultibetLoginMessage = withConfig(theme => styled('p', { label: 'MultibetLoginMessage' })`
    color: ${theme.star.eventRow.txtColor};
    font-size: ${theme.star.fontSize.regular};
    line-height: 1.5;
    margin: 0 0 16px 0;
    max-width: 300px;
`);

export const MultibetLoginButton = withConfig(theme => styled('button', { label: 'MultibetLoginButton' })`
    background-color: ${theme.star.buttons.primary.bgColor};
    border: 0;
    color: ${theme.star.buttons.primary.txtColor};
    cursor: pointer;
    display: inline-block;
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1;
    padding: 12px 32px;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    transition: .2s ease opacity;
    z-index: ${theme.star.zIndexGlobal.base};

    &:active,
    &:focus {
        outline: none;
    }

    &::before {
        background-color: ${theme.star.buttons.primary.bgColorSecondary};
        bottom: 0;
        content: '';
        left: 0;
        opacity: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: .2s ease opacity;
        z-index: ${theme.star.zIndexGlobal.below};
    }

    &:hover {
        &::before {
            opacity: 1;
        }
    }
`);
